
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-started/thank-you",
      function () {
        return require("private-next-pages/get-started/thank-you/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-started/thank-you"])
      });
    }
  